import axiosPrivate from "@services/axiosPrivate";

export const updatePatient = (patientId, patientObject) => {
  return axiosPrivate.put(`/updatePatient/${patientId}`, patientObject);
};
